import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "paper-info-block"
}
const _hoisted_3 = { class: "paper-info-status" }
const _hoisted_4 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_5 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "paper-info-actions" }
const _hoisted_8 = {
  key: 1,
  class: "paper-info-block"
}
const _hoisted_9 = { class: "paper-info-actions" }
const _hoisted_10 = { class: "timeline-item" }
const _hoisted_11 = { class: "timeline-item__property" }
const _hoisted_12 = { class: "timeline-item__property" }
const _hoisted_13 = { class: "timeline-item__property" }
const _hoisted_14 = { class: "timeline-item__property" }
const _hoisted_15 = { class: "timeline-item__property" }
const _hoisted_16 = { class: "timeline-item__property" }
const _hoisted_17 = { class: "timeline-item__property" }
const _hoisted_18 = { class: "timeline-item__property" }
const _hoisted_19 = { class: "timeline-item__property" }
const _hoisted_20 = { class: "timeline-item__property" }
const _hoisted_21 = { class: "timeline-item__property" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

import { ref, onMounted, computed } from 'vue'
import { ElNotification } from 'element-plus'
import { formatDateWithTime } from '@/helpers/date'
import {
  createPaper,
  cancelPaper,
  getTripPaper,
} from '@/api/portal-car-sharing'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import type { AxiosError } from 'axios'
import type { EvTripExtended } from '@/models/evTrip'

interface PortalPaperLog {
  id: string
  owner_car_id: string
  owner_ev_car_id: string | null
  user_id: string
  car_profile_id: string
  ev_car_profile_id: string | null
  trip_id: string
  ev_trip_id: string | null
  birth_date: string
  expire_date: string
  license_series: string
  license_number: number
  car_number: string
  raw_payload: string
  response: string
  duration_month: number
  duration_day: number
  duration_hour: number
  type: string
  created_at: string
  updated_at: string
  paper_id: string
  status: string
  isEvRequest: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalPaperForEvTrip',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const logs = ref<PortalPaperLog[]>([])
const isLoading = ref(false)
const error = ref<string | null>(null)
const paperState = ref<'idle' | 'loading' | 'success' | 'error'>('idle')
const paperInfo = ref<any | null>(null)
const paperInfoLoading = ref(false)

const paperStatus = computed(() => {
  const status = paperInfo.value?.status
  if (typeof status !== 'string') {
    return ''
  }
  return status.toLowerCase().trim()
})

const hasValidPaperInfo = computed(() => {
  return Boolean(paperInfo.value?.paper_id && paperStatus.value)
})

const canResendPaper = computed(() => {
  return paperStatus.value === 'canceled' || paperStatus.value === 'failed'
})

const fetchLogs = async () => {
  isLoading.value = true
  error.value = null

  const params = {
    ev_trip_id: props.trip.id,
  }

  try {
    const response = await getTripPaper(params)
    let data: PortalPaperLog[] = []
    if (Array.isArray(response.data)) {
      data = response.data
    } else if (response.data && typeof response.data === 'object') {
      data = [response.data]
    }
    data.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
    logs.value = data
    paperInfo.value = data.length ? data[data.length - 1] : null
  } catch (e: unknown) {
    const err = e as AxiosError<any>
    if (
      err.response &&
      (err.response.status === 404 ||
        (err.response.data &&
          (err.response.data.message === 'Not found' ||
            err.response.data.errors?.message?.includes('No papers found'))))
    ) {
      logs.value = []
      paperInfo.value = null
      error.value = null
    } else {
      error.value = 'Error loading logs'
    }
  } finally {
    isLoading.value = false
  }
}

const handleCreatePaper = async () => {
  paperState.value = 'loading'
  try {
    await createPaper({
      ev_trip_id: props.trip.id,
      type: 'ev',
    })
    ElNotification({
      title: 'Success',
      message: 'Paper created successfully!',
      type: 'success',
      position: 'top-right',
    })
    await fetchLogs()
    paperState.value = 'success'
  } catch (e) {
    let message = 'Paper creation failed'
    if (
      typeof e === 'object' &&
      e &&
      'response' in e &&
      e.response &&
      typeof e.response === 'object' &&
      'data' in e.response &&
      e.response.data &&
      typeof e.response.data === 'object' &&
      'message' in e.response.data
    ) {
      message = (e.response.data as { message?: string }).message || message
    } else if (e instanceof Error) {
      message = e.message
    }
    ElNotification({
      title: 'Error',
      message,
      type: 'error',
      position: 'top-right',
    })
    fetchLogs()
    paperState.value = 'error'
  }
}

const handleCancelPaper = async () => {
  paperInfoLoading.value = true
  try {
    await cancelPaper({
      ev_trip_id: props.trip.id,
      type: 'ev',
      paper_id: paperInfo.value.paper_id,
    })
    ElNotification({
      title: 'Success',
      message: 'Paper canceled!',
      type: 'success',
      position: 'top-right',
    })
    await fetchLogs()
  } catch (e) {
    ElNotification({
      title: 'Error',
      message: 'Failed to cancel paper',
      type: 'error',
      position: 'top-right',
    })
  } finally {
    paperInfoLoading.value = false
  }
}

function parseResponseMessage(response: string): string {
  try {
    const obj = JSON.parse(response)
    return obj.message || response
  } catch {
    return response
  }
}

onMounted(fetchLogs)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: fetchLogs
      }, null, 8, ["errorMessage"]))
    : (isLoading.value && !logs.value.length)
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "title" }, "Portal Paper for EV Trip", -1)),
                      (hasValidPaperInfo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("span", null, [
                              _cache[0] || (_cache[0] = _createElementVNode("b", null, "Paper ID:", -1)),
                              _createTextVNode(" " + _toDisplayString(paperInfo.value.paper_id), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[1] || (_cache[1] = _createElementVNode("b", null, "EV Trip ID:", -1)),
                              _createTextVNode(" " + _toDisplayString(paperInfo.value.ev_trip_id || paperInfo.value.trip_id), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[2] || (_cache[2] = _createElementVNode("b", null, "Type:", -1)),
                              _createTextVNode(" " + _toDisplayString(paperInfo.value.type), 1)
                            ]),
                            _createElementVNode("span", _hoisted_3, [
                              _cache[3] || (_cache[3] = _createElementVNode("b", null, "Status:", -1)),
                              (paperStatus.value === 'registered')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Registered"))
                                : (paperStatus.value === 'canceled')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Canceled"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(paperInfo.value.status), 1))
                            ]),
                            _createElementVNode("span", _hoisted_7, [
                              (paperStatus.value === 'registered')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "danger",
                                    onClick: handleCancelPaper,
                                    loading: paperInfoLoading.value
                                  }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                      _createTextVNode(" Cancel ")
                                    ])),
                                    _: 1,
                                    __: [4]
                                  }, 8, ["loading"]))
                                : (canResendPaper.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 1,
                                      type: "primary",
                                      onClick: handleCreatePaper,
                                      loading: paperState.value === 'loading'
                                    }, {
                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode(" Create Paper ")
                                      ])),
                                      _: 1,
                                      __: [5]
                                    }, 8, ["loading"]))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: handleCreatePaper,
                                loading: paperState.value === 'loading'
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode(" Create Paper ")
                                ])),
                                _: 1,
                                __: [6]
                              }, 8, ["loading"])
                            ])
                          ]))
                    ]),
                    (logs.value.length)
                      ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...logs.value].reverse(), (log) => {
                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                key: log.id,
                                timestamp: _unref(formatDateWithTime)(log.created_at),
                                placement: "top",
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _cache[8] || (_cache[8] = _createElementVNode("b", null, "Paper ID:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.paper_id), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                      _cache[9] || (_cache[9] = _createElementVNode("b", null, "Status:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.status), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                      _cache[10] || (_cache[10] = _createElementVNode("b", null, "Type:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.type), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _cache[11] || (_cache[11] = _createElementVNode("b", null, "Car number:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.car_number), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                      _cache[12] || (_cache[12] = _createElementVNode("b", null, "License series:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.license_series), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _cache[13] || (_cache[13] = _createElementVNode("b", null, "License number:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.license_number), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                      _cache[14] || (_cache[14] = _createElementVNode("b", null, "Birth date:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.birth_date), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _cache[15] || (_cache[15] = _createElementVNode("b", null, "Expire date:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.expire_date), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      _cache[16] || (_cache[16] = _createElementVNode("b", null, "Duration:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.duration_month) + "m " + _toDisplayString(log.duration_day) + "d " + _toDisplayString(log.duration_hour) + "h ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _cache[17] || (_cache[17] = _createElementVNode("b", null, "Raw payload:", -1)),
                                      _createTextVNode(" " + _toDisplayString(log.raw_payload), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _cache[18] || (_cache[18] = _createElementVNode("b", null, "Response:", -1)),
                                      (log.response)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(parseResponseMessage(log.response)), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["timestamp"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_23, "No Logs"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})